// extracted by mini-css-extract-plugin
export default {"primaryTitle":"UPwMO","userPersona":"dAQMe","mailSurfaceHeader":"rBByX","hasSecondaryHeader":"GUxUH","icon":"Ng5Bs","isButtonPressed":"uw_9B"};